// Norwegian bokmål UI strings. Single source — no i18n machinery at MVP.
// Per ADR-0014: when a second language is wanted, this file becomes the seed for a real i18n setup.

export const nb = {
  app: {
    name: 'Hesnesøya',
  },
  common: {
    close: 'Lukk',
    back: 'Tilbake',
    cancel: 'Avbryt',
    confirm: 'Bekreft',
  },
  landing: {
    tagline: 'Familiehytte for fam. Tungesvik og Nilsen',
    wordmarkAlt: 'Hesnesøya',
  },
  modules: {
    comingSoon: 'Kommer snart',
    comingSoonBody: 'Denne delen er under arbeid og kommer i en senere oppdatering.',
    omHytta: { title: 'Om hytta', desc: 'Historien om hytta og slekten siden 1941.' },
    utforsk: {
      title: 'Utforsk området',
      desc: 'Kart med badeplasser, fiskeplasser og severdigheder.',
    },
    gjestebok: { title: 'Gjestebok', desc: 'Den fysiske gjesteboka under stuebordet.' },
    galleri: { title: 'Galleri', desc: 'Bilder fra somre og generasjoner.' },
    vedlikehold: { title: 'Vedlikehold', desc: 'Hva slags stell hytta og tomta trenger.' },
    regler: {
      title: 'Hytteregler og -rutiner',
      desc: 'Ordensregler, avreise- og stengerutiner.',
    },
    eier: { title: 'Eierseksjon', desc: 'Dokumenter og beslutninger for eierne.' },
    faq: { title: 'Vanlige spørsmål', desc: 'Svar på det folk ofte lurer på.' },
  },
  documents: {
    loadError: 'Klarte ikke å laste innholdet akkurat nå. Prøv igjen senere.',
    omHytta: {
      editContent: 'Rediger innhold',
    },
    regler: {
      editSubcard: 'Rediger',
      subcards: {
        ordensregler: 'Ordensregler',
        avreiserutiner: 'Avreiserutiner',
        stengerutiner: 'Stengerutiner',
      },
    },
    editor: {
      editPrefix: 'Rediger:',
      save: 'Lagre',
      saved: 'Lagret',
      sourceLabel: 'Markdown',
      sourceAria: 'Markdown-kilde',
      previewLabel: 'Forhåndsvisning',
      help: 'Markdown-hjelp',
      cheatSheet:
        '**fet**  ·  *kursiv*  ·  # Overskrift  ·  - punktliste  ·  1. nummerert  ·  > sitat  ·  [lenke](https://…)',
      basedOn: 'Basert på versjon',
      lastEditedBy: 'sist endret av',
      conflictTitle: 'Innhold er endret av en annen admin — last inn på nytt.',
      conflictBody:
        'Endringene dine er ikke lagret. Last inn den nyeste versjonen før du redigerer videre (HTTP 409).',
      reload: 'Last inn på nytt',
      backToPage: 'Tilbake til siden',
      backToList: 'Tilbake til Innhold',
      savedToastTitle: 'Lagret',
      savedToastBody: '«{tittel}» er oppdatert (versjon {versjon}).',
      reloadedToastTitle: 'Lastet inn på nytt',
      reloadedToastBody: 'Du ser nå den nyeste versjonen (v{versjon}).',
      saveErrorTitle: 'Klarte ikke å lagre',
      saveErrorBody: 'Noe gikk galt under lagringen. Prøv igjen.',
    },
  },
  footer: {
    personvern: 'Personvern',
    kontakt: 'Kontakt',
    loggInn: 'Logg inn / be om tilgang',
    rediger: 'Rediger',
    avsluttRediger: 'Avslutt redigering',
    minProfil: 'Min profil',
    loggUt: 'Logg ut',
    admin: 'Admin',
  },
  personvern: {
    heading: 'Personvern',
    body: 'Personvernerklæringen er ikke ferdigskrevet ennå. Den blir oppdatert i en senere iterasjon — før vi åpner for innlogging og bidrag.',
    backToFront: 'Tilbake til forsiden',
  },
  kontakt: {
    heading: 'Kontakt',
    body: 'Kontaktinformasjon kommer i en senere oppdatering. Ta kontakt med eierne ved spørsmål om hytta eller tilgang.',
    backToFront: 'Tilbake til forsiden',
  },
  profil: {
    heading: 'Min profil',
    body: 'Profilsiden er ikke ferdig ennå. Her vil du senere kunne se og endre opplysningene dine.',
    backToFront: 'Tilbake til forsiden',
  },
  nav: {
    requestAccess: 'Be om tilgang',
    logout: 'Logg ut',
    edit: 'Rediger',
  },
  cards: {
    omHytta: 'Om hytta',
    utforskOmradet: 'Utforsk området',
    gjestebok: 'Gjestebok',
    galleri: 'Galleri',
    vedlikehold: 'Vedlikehold',
    hytteregler: 'Hytteregler og -rutiner',
    eierseksjon: 'Eierseksjon',
    faq: 'Vanlige spørsmål',
    comingSoon: 'Kommer snart',
  },
  auth: {
    emailEntryResponse:
      'Takk! Hvis e-posten din er registrert, har du fått en innloggings-lenke. Ellers er forespørselen din mottatt og blir vurdert av eierne.',
    linkExpired:
      'Lenken har utløpt eller er allerede brukt. Be om en ny ved å fylle inn skjemaet på nytt.',
    form: {
      title: 'Logg inn eller be om tilgang',
      modeLabel: 'Velg handling',
      modeLogin: 'Logg inn',
      modeRequest: 'Be om tilgang',
      loginLede:
        'Har du tilgang fra før? Skriv inn e-posten din, så sender vi deg en innloggings-lenke.',
      requestLede:
        'Ny her? Skriv inn e-post, navn og hvem som er vert for deg. Forespørselen sendes til eierne for vurdering.',
      emailLabel: 'E-post',
      nameLabel: 'Navn',
      hostLabel: 'Vert',
      hostHelp: 'Hvem inviterer deg, eller er vert for besøket?',
      loginSubmit: 'Send innloggings-lenke',
      requestSubmit: 'Send forespørsel',
      emailRequired: 'E-post må fylles ut.',
      emailInvalid: 'Skriv inn en gyldig e-postadresse.',
      nameRequired: 'Navn må fylles ut.',
      nameMax: 'Navnet kan ikke være lengre enn 64 tegn.',
      hostRequired: 'Vert må fylles ut.',
      hostMax: 'Verten kan ikke være lengre enn 96 tegn.',
    },
  },
  gjestebok: {
    body: 'Vi setter veldig pris på om dere forteller litt om oppholdet i gjesteboka vår. Dere finner den under stuebordet :-)',
    photoAlt: 'Den fysiske gjesteboka i hytta',
  },
  eier: {
    lead: 'Eierseksjonen er forbeholdt eierne. Her samler vi det som angår selve eierskapet — dokumenter, innlegg, beslutninger og kontaktinformasjon.',
    subsectionsLabel: 'Dette kommer i eierseksjonen:',
    subsections: ['Dokumenter', 'Innlegg fra eiere', 'Beslutninger', 'Kontaktliste'],
  },
  faq: {
    invitation: 'Vanlige spørsmål — kommer snart. Send gjerne forslag på e-post.',
    email: 'nilsenjona@gmail.com',
    emailAria: 'Send forslag på e-post til nilsenjona@gmail.com',
  },
  map: {
    title: 'Utforsk området',
    closeAria: 'Lukk kart',
    cabinAria: 'Hytta',
    attribution: '© Kartverket',
    attributionOsm: '© OpenStreetMap contributors',
    loadError: 'Klarte ikke å laste kartet akkurat nå. Prøv igjen senere.',
    fallbackNotice: 'Sjøkart ikke tilgjengelig — viser OpenStreetMap.',
    addHint: 'Hold inne / høyreklikk for å legge til et sted',
    modes: {
      sjokart: 'Sjøkart',
      topo: 'Topografisk',
      flyfoto: 'Flyfoto',
      flyfotoBadge: 'snart',
    },
    categories: {
      swimming: 'Badeplass',
      fishing: 'Fiskeplass',
      mooring: 'Fortøyning',
      sight: 'Severdighed',
      food: 'Mad/Rast',
      acquaintance: 'Bekjentskab',
      other: 'Annet',
    },
    popup: {
      edit: 'Rediger',
      delete: 'Slett',
      ariaClose: 'Lukk infoboks',
      contributedBy: 'Lagt til av',
    },
    add: {
      title: 'Legg til sted',
      lede: 'Velg kategori, gi stedet et navn og evt. en kommentar.',
      categoryLabel: 'Kategori',
      nameLabel: 'Navn',
      namePlaceholder: 'F.eks. Sandbukta',
      commentLabel: 'Kommentar',
      commentPlaceholder: 'Valgfritt — kort beskrivelse.',
      coordsLabel: 'Koordinater',
      submit: 'Legg til',
      cancel: 'Avbryt',
      addedTitle: 'Lagt til',
      addedBody: '«{navn}» er nå på kartet.',
      errorTitle: 'Klarte ikke å lagre',
      errorBody: 'Prøv igjen om litt.',
    },
    edit: {
      title: 'Rediger sted',
      lede: 'Posisjonen er låst — endre kategori, navn eller kommentar.',
      submit: 'Lagre',
      savedTitle: 'Lagret',
      savedBody: '«{navn}» er oppdatert.',
    },
    deleteDialog: {
      title: 'Slette «{navn}»?',
      body: 'Stedet skjules umiddelbart, men kan gjenopprettes innen 30 dager.',
      confirm: 'Slett sted',
      deletedTitle: 'Slettet',
      deletedBody: '«{navn}» er fjernet fra kartet.',
    },
    validation: {
      categoryRequired: 'Velg en kategori.',
      nameRequired: 'Stedet må ha et navn.',
      nameMax: 'Navnet er for langt.',
      commentMax: 'Kommentaren er for lang.',
    },
  },
  vedlikehold: {
    title: 'Vedlikehold',
    closeAria: 'Lukk vedlikehold',
    subcards: {
      generelt: 'Generelt vedlikehold',
      generelDesc: 'Hva slags stell hytta og tomta trenger.',
      dugnad: 'Dugnadsoppgaver',
      dugnadDesc: 'Felles oppgaver som må gjøres.',
    },
    dugnad: {
      empty: 'Ingen dugnadsoppgaver ennå. Bidra ved å slå på «Rediger» nederst.',
      loadError: 'Klarte ikke å laste dugnadsoppgavene. Prøv igjen senere.',
      add: 'Legg til oppgave',
      contributedBy: 'Lagt til av',
      edit: 'Rediger',
      delete: 'Slett',
      imageAlt: 'Bilde for dugnadsoppgave',
      assign: 'Tildel ansvarlig',
      reassign: 'Endre ansvarlig',
      changeStatus: 'Endre status',
      assignedTo: 'Ansvarlig:',
      // Keyed by the status wire value so a row looks up its own label directly.
      statusLabel: {
        åpen: 'Åpen',
        tildelt: 'Tildelt',
        utført: 'Utført',
        kansellert: 'Kansellert',
      },
    },
    generelt: {
      empty: 'Ingen oppføringer ennå. Bidra ved å slå på «Rediger» nederst.',
      loadError: 'Klarte ikke å laste oppføringene. Prøv igjen senere.',
      add: 'Legg til vedlikehold',
      manageKategorier: 'Administrer kategorier',
      contributedBy: 'Lagt til av',
      edit: 'Rediger',
      delete: 'Slett',
      imageAlt: 'Bilde for vedlikeholdsoppføring',
    },
    addModal: {
      title: 'Legg til vedlikehold',
      dugnadTitle: 'Legg til dugnadsoppgave',
      kategoriLabel: 'Kategori',
      kategoriPlaceholder: 'Velg kategori',
      newKategori: '+ Ny kategori',
      newKategoriPlaceholder: 'Navn på ny kategori',
      newKategoriSubmit: 'Opprett',
      descriptionLabel: 'Beskrivelse',
      descriptionHelp: 'Maks 1024 tegn.',
      imageLabel: 'Bilde — valgfritt',
      imageUpload: 'Last opp bilde',
      imageRemove: 'Fjern bilde',
      imagePreparing: 'Klargjør bildet …',
      submit: 'Lagre',
      cancel: 'Avbryt',
      errorTitle: 'Klarte ikke å lagre',
      validation: {
        kategoriRequired: 'Velg en kategori.',
        descriptionRequired: 'Beskrivelse må fylles ut.',
        descriptionMax: 'Beskrivelsen er for lang (maks 1024 tegn).',
        kategoriNameRequired: 'Kategorien må ha et navn.',
        kategoriNameMax: 'Navnet er for langt (maks 64 tegn).',
      },
      savedTitle: 'Lagret',
      savedBody: 'Oppføringen er lagt til.',
    },
    editModal: {
      title: 'Rediger vedlikehold',
      dugnadTitle: 'Rediger dugnadsoppgave',
      kategoriLabel: 'Kategori — kan flyttes',
      imageLabel: 'Bilde',
      imageReplace: 'Erstatt bilde',
      imageNone: 'Ingen bilde',
      submit: 'Lagre',
      savedTitle: 'Lagret',
      savedBody: 'Endringene er lagret.',
    },
    deleteDialog: {
      title: 'Slette oppføring?',
      body: 'Oppføringen skjules umiddelbart, men kan gjenopprettes innen 30 dager. Et tilhørende bilde fjernes også.',
      confirm: 'Slett oppføring',
      deletedTitle: 'Slettet',
      deletedBody: 'Oppføringen er fjernet.',
    },
    dugnadDeleteDialog: {
      title: 'Slette oppgave?',
      body: 'Oppgaven skjules umiddelbart, men kan gjenopprettes innen 30 dager. Et tilhørende bilde fjernes også.',
      confirm: 'Slett oppgave',
    },
    assignModal: {
      title: 'Tildel ansvarlig',
      help: 'Velg hvem som skal ha oppgaven. Alle som er innlogget kan tildele — uavhengig av hvem som opprettet oppgaven.',
      submit: 'Lagre',
      loadError: 'Klarte ikke å laste brukere.',
      empty: 'Ingen brukere å tildele.',
      errorTitle: 'Klarte ikke å tildele',
      currentHint: '(nåværende)',
    },
    statusModal: {
      title: 'Endre status',
      help: 'Alle statuser unntatt «Åpen» krever en ansvarlig. «Åpen» fjerner ansvarlig.',
      errorTitle: 'Klarte ikke å endre status',
      currentHint: '(nåværende)',
    },
    kategoriManagement: {
      title: 'Administrer kategorier',
      add: 'Ny kategori',
      addSubmit: 'Opprett',
      renameLabel: 'Endre navn',
      delete: 'Slett',
      deleteDisabledTooltip: 'Kategorien har oppføringer — flytt eller slett dem først.',
      empty: 'Ingen kategorier ennå.',
      conflict:
        'Kan ikke slette en kategori som har oppføringer. Flytt eller slett oppføringene først.',
    },
    viewer: {
      label: 'Bildevisning',
      openAria: 'Forstørr bilde',
      closeAria: 'Lukk bildevisning',
    },
  },
  galleri: {
    upload: 'Last opp',
    loadMore: 'Last flere',
    loadingMore: 'Laster flere bilder …',
    empty: 'Ingen bilder ennå.',
    loadError: 'Klarte ikke å laste galleriet akkurat nå. Prøv igjen senere.',
    contributedBy: 'lagt til av',
    thumbAria: 'Vis bilde',
    uploadModal: {
      title: 'Last opp bilde',
      imageLabel: 'Bilde',
      imagePick: 'Dra hit eller velg fil',
      imageReplace: 'Bytt bilde',
      formatNote: 'JPEG, PNG eller HEIC · store bilder komprimeres automatisk til under 8 MB',
      preparing: 'Klargjør bildet …',
      captionLabel: 'Bildetekst — påkrevd',
      captionPlaceholder: 'Skriv en kort bildetekst …',
      submit: 'Last opp',
      validation: {
        imageRequired: 'Velg et bilde.',
        imageTooLarge: 'Bildet er for stort. Maks 20 MB.',
        imageTooBig: 'Bildet er for stort (maks 6000×6000 piksler).',
        captionRequired: 'Bildetekst er påkrevd.',
        captionMax: 'Bildeteksten er for lang (maks 256 tegn).',
      },
      errorTitle: 'Noe gikk galt',
    },
    viewer: {
      label: 'Bildevisning',
      closeAria: 'Lukk bildevisning',
      editCaption: 'Rediger tekst',
      captionEditAria: 'Rediger bildetekst',
      captionPlaceholder: 'Skriv en bildetekst …',
      delete: 'Slett',
      saveError: 'Klarte ikke å lagre bildeteksten. Prøv igjen.',
    },
    deleteDialog: {
      title: 'Slette bildet?',
      body: 'Bildet og bildeteksten slettes sammen. En administrator kan gjenopprette det i 30 dager.',
      confirm: 'Slett bilde',
    },
  },
  roles: {
    admin: 'Administrator',
    owner: 'Eier',
    registered_guest: 'Gjest',
  },
  admin: {
    eyebrow: 'Administrasjon',
    backToPortal: 'Tilbake til portalen',
    nav: {
      users: 'Brukere',
      accessRequests: 'Ventende forespørsler',
      content: 'Innhold',
      auditLog: 'Logg',
    },
    users: {
      title: 'Brukere',
      lede: 'Alle brukere med navn, e-post, rolle og siste innlogging.',
      add: 'Legg til bruker',
      colName: 'Navn',
      colEmail: 'E-post',
      colRole: 'Rolle',
      colHost: 'Vert',
      colLastLogin: 'Siste innlogging',
      colActions: 'Handlinger',
      neverLoggedIn: 'Aldri',
      remove: 'Fjern',
      editHint: 'Slå på «Rediger» i bunnteksten for å endre roller eller fjerne brukere.',
      empty: 'Ingen brukere ennå.',
    },
    removeDialog: {
      title: 'Fjerne {navn}?',
      body: 'Brukeren mister tilgang, økter avsluttes, og bidrag anonymiseres. Dette kan ikke angres.',
      confirm: 'Fjern bruker',
    },
    invite: {
      title: 'Legg til bruker',
      lede: 'Inviter en ny bruker med e-post, navn og rolle. Det sendes en innloggings-lenke.',
      emailLabel: 'E-post',
      nameLabel: 'Navn',
      roleLabel: 'Rolle',
      submit: 'Send invitasjon',
    },
    accessRequests: {
      title: 'Ventende forespørsler',
      lede: 'Forespørsler om tilgang fra folk uten konto. Godkjenn for å sende invitasjon.',
      empty: 'Ingen ventende forespørsler akkurat nå.',
      sentPrefix: 'Sendt',
      hostPrefix: 'Vert',
      approve: 'Godkjenn',
      decline: 'Avslå',
    },
    content: {
      title: 'Innhold',
      lede: 'Rediger tekstinnholdet på sidene. Endringer logges og vises umiddelbart for alle.',
      edit: 'Rediger',
      empty: 'Ingen dokumenter ennå.',
    },
    auditLog: {
      title: 'Logg',
      lede: 'Hvem gjorde hva, når. Oppbevares i 2 år (revisjonshensyn).',
      empty: 'Loggen er tom.',
    },
    toast: {
      roleChangedTitle: 'Rolle endret',
      roleChangedBody: 'Trer i kraft ved neste innlogging.',
      removedTitle: 'Bruker fjernet',
      removedBody: '{navn} er fjernet og bidrag anonymisert.',
      invitedTitle: 'Invitasjon sendt',
      invitedBody: '{navn} har fått en innloggings-lenke.',
      approvedTitle: 'Forespørsel godkjent',
      approvedBody: '{navn} er lagt til som registrert gjest; invitasjon sendt.',
      declinedTitle: 'Forespørsel avslått',
      declinedBody: 'Forespørselen er fjernet fra listen.',
      errorTitle: 'Noe gikk galt',
    },
  },
  errors: {
    generic: 'Noe gikk galt — prøv igjen om litt.',
    notFound: 'Siden finnes ikke.',
    notFoundCta: 'Tilbake til forsiden',
  },
};

export type Translations = typeof nb;
